import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { CartShop } from '../_components/CartShopGroup';
import { isProductSoldOut } from '../_utils/cartCalculations';
export const useCartCheckState = serverShops => {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [shops, setShops] = useState(t0);
  let t1;
  let t2;
  if ($[1] !== serverShops) {
    t1 = () => {
      if (!serverShops.length) {
        setShops([]);
        return;
      }
      setShops(prev => {
        const prevCheckMap = new Map();
        const prevProductCheckMap = new Map();
        for (const shop of prev) {
          prevCheckMap.set(shop.mallVendorId, shop.checked);
          for (const product of shop.products) {
            prevProductCheckMap.set(`${shop.mallVendorId}:${product.mallProductId}`, product.checked);
          }
        }
        const isFirstLoad = prev.length === 0;
        return serverShops.map(shop_0 => ({
          ...shop_0,
          checked: isFirstLoad ? true : prevCheckMap.get(shop_0.mallVendorId) ?? true,
          products: shop_0.products.map(product_0 => ({
            ...product_0,
            checked: isFirstLoad ? true : prevProductCheckMap.get(`${shop_0.mallVendorId}:${product_0.mallProductId}`) ?? true
          }))
        }));
      });
    };
    t2 = [serverShops];
    $[1] = serverShops;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== shops) {
    t3 = shops.length > 0 && shops.every(_temp2);
    $[4] = shops;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const allChecked = t3;
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = checked => {
      setShops(prev_0 => prev_0.map(shop_2 => ({
        ...shop_2,
        checked,
        products: shop_2.products.map(product_2 => ({
          ...product_2,
          checked: checked ? !isProductSoldOut(product_2) : false
        }))
      })));
    };
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleAllCheck = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = (mallVendorId, checked_0) => {
      setShops(prev_1 => prev_1.map(shop_3 => shop_3.mallVendorId === mallVendorId ? {
        ...shop_3,
        checked: checked_0,
        products: shop_3.products.map(product_3 => ({
          ...product_3,
          checked: checked_0 ? !isProductSoldOut(product_3) : false
        }))
      } : shop_3));
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleShopCheck = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = (mallVendorId_0, mallProductId, checked_1) => {
      setShops(prev_2 => prev_2.map(shop_4 => {
        if (shop_4.mallVendorId !== mallVendorId_0) {
          return shop_4;
        }
        const updatedProducts = shop_4.products.map(product_4 => product_4.mallProductId === mallProductId ? {
          ...product_4,
          checked: checked_1
        } : product_4);
        return {
          ...shop_4,
          checked: updatedProducts.every(_temp3),
          products: updatedProducts
        };
      }));
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleProductCheck = t6;
  let t7;
  if ($[9] !== allChecked || $[10] !== shops) {
    t7 = {
      shops,
      setShops,
      allChecked,
      handleAllCheck,
      handleShopCheck,
      handleProductCheck
    };
    $[9] = allChecked;
    $[10] = shops;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
function _temp(product_1) {
  return product_1.checked;
}
function _temp2(shop_1) {
  return shop_1.checked && shop_1.products.every(_temp);
}
function _temp3(product_5) {
  return product_5.checked;
}